import React from 'react';
import request from '../../../request';
import Input from '../../shared/labelInput';
import Select from '../../shared/select';

export default class AddUser extends React.Component {
  constructor() {
    super();
    this.admin = localStorage.getItem('type') === 'admin';
    this.state = {
      user: {},
      type: this.admin ? 'Admin' : 'Staff',
      staffOnly: !this.admin,
      companies: [],
      selectedCompanies: [],
    };
  }

  componentDidMount() {
    if (!this.admin) this.loadCompanies('Staff');
  }

  async loadCompanies(type) {
    try {
      this.setState({ loading: true, type });
      let companies = await request({
        url: `admin/companies?all=true`,
        method: 'GET',
      });

      this.setState({ companies: companies, loading: false });
    } catch (e) {
      this.setState({ loading: false, error: e.message || e });
    }
  }

  async create() {
    let { user, type, selectedCompanies } = this.state;
    try {
      this.setState({ loading: true });
      await request({
        url: `invites/create`,
        method: 'POST',
        body: {
          ...user,
          type,
          selected_companies: selectedCompanies.join(','),
        },
      });
      if (!this.admin)
        return this.setState({
          user: {},
          loading: false,
          error: 'User has been invited',
          selectedCompanies: [],
        });
      this.setState({
        user: {},
        loading: false,
        type: 'Admin',
        companies: [],
        selectedCompanies: [],
        error: 'User has been invited',
      });
    } catch (e) {
      this.setState({
        loading: false,
        error: e.message || e,
        user: { ...this.state.user, password: null, password_confirm: null },
      });
    }
  }

  toggleCompany(id) {
    let { selectedCompanies } = this.state;
    let index = selectedCompanies.findIndex(company => company === id);
    if (index !== -1) selectedCompanies.splice(index, 1);
    else selectedCompanies.push(id);
    this.setState({ selectedCompanies });
  }

  render() {
    let {
      user,
      loading,
      error,
      type,
      companies,
      staffOnly,
      selectedCompanies,
    } = this.state;

    return (
      <div id="dashboard" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Add Staff</h5>
        {error ? <p className="error">{error}</p> : null}

        {!staffOnly
          ? <Select
              name="type"
              label="Type"
              value={type}
              onChange={type => {
                if (type !== 'Admin') return this.loadCompanies(type);
                this.setState({ type, companies: [] });
              }}
              items={[
                { value: 'Admin', label: 'Global Admin' },
                { value: 'Company Admin', label: 'Company Admin' },
                { value: 'Staff', label: 'Staff' },
              ]}
            />
          : null}
        <Input
          name="first_name"
          label="First Name"
          value={user.first_name || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          name="last_name"
          label="Last Name"
          value={user.last_name || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          id="email_field"
          name="email"
          label="Email"
          value={user.email || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        {companies.length > 0
          ? <div>
              <h5 className="dots">Companies</h5>
              <div id="admin-cols">
                <ul id="admin-cols-ul">
                  {companies.map(company => (
                    <li key={company.id}>
                      <input
                        type="checkbox"
                        name={company.name}
                        value={company.id}
                        className="on"
                        checked={
                          selectedCompanies.find(
                            id => parseInt(id, 10) === parseInt(company.id, 10)
                          ) || ''
                        }
                        onChange={e =>
                          this.toggleCompany(parseInt(e.target.value, 10))}
                      />
                      <label htmlFor="company">{company.name}</label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          : null}

        <div className="options">
          <button
            className="control_button"
            id="save"
            onClick={() => this.create()}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/users/add-user.js